// Copyright (c) 2026. Citrix Systems, Inc. All Rights Reserved. Confidential & Proprietary

/**
 * Centralized user-facing strings for the Account Management feature.
 * All text rendered in AccountManagementPage, StoresPage and EditStorePage
 * must be sourced from here so they are easy to find and adapt for localization.
 */

export const ACCOUNT_MANAGEMENT_STRINGS = {
	// ── StoresPage ────────────────────────────────────────────────────────────
	storesTitle: 'Stores',
	searchPlaceholder: 'Search store or url',
	tableAriaLabel: 'Stores list',
	columnShowInMenu: 'Show in menu',
	columnStoreName: 'Store name',
	columnActionsAriaLabel: 'Actions',
	/** @param storeName – display name of the store */
	toggleAriaLabel: (storeName: string) => `Show ${storeName} in menu`,
	primaryBadge: 'Primary',
	/** @param storeName – display name of the store */
	moreOptionsAriaLabel: (storeName: string) => `More options for ${storeName}`,
	/** @param storeName – display name of the store */
	flyoutAriaLabel: (storeName: string) => `Options for ${storeName}`,
	flyoutEdit: 'Edit',
	flyoutRemove: 'Remove',
	emptyState: 'No stores match your search.',

	// ── Remove-store confirmation modal ───────────────────────────────────────
	/** @param storeName – display name of the store being removed */
	removeModalTitle: (storeName: string) => `Remove store ${storeName}?`,
	removeModalDescription:
		'Removing the store will delete all applications from your local device.',
	removeModalConfirmButton: 'Remove',
	removeModalCancelButton: 'Cancel',

	// ── EditStorePage ─────────────────────────────────────────────────────────
	editStoreBackAriaLabel: 'Go back',
	editStoreTitle: 'Edit store',
	editStoreNameLabel: 'Store name',
	editStoreUrlLabel: 'Store URL',
	editStoreDescriptionLabel: 'Description',
	editStoreSaveButton: 'Save',
	editStoreCancelButton: 'Cancel',
};
